import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { apiRoute } from "../Globals";
import { useRecoilState } from "recoil";
import { userAuthToken } from "../atoms/authToken";

export default function UpdateTemplate() {
  const { id, token } = useParams();
  const [name, setName] = useState("");
  const [device, setDevice] = useState("");
  const [desc, setDesc] = useState("");
  const [loading, setLoading] = useState(true);
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [pin, setPin] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [wifiSSID, setWifiSSID] = useState("");
  const [wifiPass, setWifiPass] = useState("");
  const [userCompany, setUserCompany] = useState("");
  const [address, setAddress] = useState("");
  const [userAuth] = useRecoilState(userAuthToken);
  const isAdmin = userAuth === 26 ? true : false;

  //fetch all device details
  useEffect(() => {
    try {
      axios
        .get(`${apiRoute}/database-firebase/description/${id}/fetch`)
        .then((Response) => {
          console.log(Response);

          setName(Response.data.data.name);
          setDevice(Response.data.data.device);
          setDesc(Response.data.data.description);
          setCity(Response.data.data.city);
          setState(Response.data.data.state);
          setPin(Response.data.data.pin);
          setUserCompany(Response.data.data.user_company);
          setAddress(Response.data.data.address);
          setLatitude(Response.data.data.latitude);
          setLongitude(Response.data.data.longitude);
          setWifiSSID(Response.data.data.wifi_ssid);
          setWifiPass(Response.data.data.wifi_pass);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error:", error); // Log any other errors
        });
    } catch (error) {
      console.error("Error:", error);
    }
  }, [id]);
  const handleSubmit = (e) => {
    e.preventDefault();

    try {
      axios
        // .post(`${apiRoute}/database-firebase/description/${id}/update`, {
        .post(`${apiRoute}/metadata/insert/${token}`, {
          name: name,
          city: city,
          state: state,
          pin: pin,
          user_company: userCompany,
          address: address,
          description: desc,
          latitude: latitude,
          longitude: longitude,
          wifi_ssid: wifiSSID,
          wifi_pass: wifiPass,
        })
        .then((Response) => {
          console.log(Response);
          alert("updated successfully");
        })
        .catch((error) => {
          console.error("Error:", error); // Log any other errors
        });
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    switch (id) {
      case "name":
        setName(value);
        break;
      case "city":
        setCity(value);
        break;
      case "state":
        setState(value);
        break;
      case "pin":
        setPin(value);
        break;
      case "user_company":
        setUserCompany(value);
        break;
      case "address":
        setAddress(value);
        break;
      case "wifiSSID":
        setWifiSSID(value);
        break;
      case "wifiPass":
        setWifiPass(value);
        break;
      case "latitude":
        setLatitude(value);
        break;
      case "longitude":
        setLongitude(value);
        break;
      default:
        break;
    }
  };

  return (
    <div>
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Edit Device Details</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/dashboard">Home</Link>
              </li>
              {/* <li className="breadcrumb-item "><Link to="/dashboard/alltemplate">All Templates</Link></li> */}
              <li className="breadcrumb-item active">
                <Link to={"/dashboard/updatetemplate"}>
                  Edit Device Details
                </Link>
              </li>
            </ol>
          </nav>
        </div>
        <section className="section dashboard" style={{ height: "87%" }}>
          <div className="d-grid gap-2 mt-3">
            <div className="row">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">Edit Below</h5>

                  <ul
                    className="nav nav-tabs d-flex"
                    id="myTabjustified"
                    role="tablist"
                  >
                    <li className="nav-item flex-fill" role="presentation">
                      <button
                        className="nav-link w-100 active"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#home-justified"
                        type="button"
                        role="tab"
                        aria-controls="home"
                        aria-selected="true"
                      >
                        Basic Information
                      </button>
                    </li>
                    {/* <li className="nav-item flex-fill" role="presentation">
                                            <button className="nav-link w-100" id="profile-tab" data-bs-toggle="tab"
                                                data-bs-target="#profile-justified" type="button" role="tab"
                                                aria-controls="profile" aria-selected="false">Meta Information</button>
                                        </li> */}
                  </ul>
                  <div className="tab-content pt-2" id="myTabjustifiedContent">
                    <div
                      className="tab-pane fade show active"
                      id="home-justified"
                      role="tabpanel"
                      aria-labelledby="home-tab"
                    >
                      <div className="">
                        <div className="">
                          <form action="" className="row" onSubmit={handleSubmit}>
                            <div className="form-floating mb-3 col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                id="name"
                                placeholder="Name"
                                value={name}
                                disabled={isAdmin ? false : true}
                                onChange={handleInputChange}
                              />
                              <label className="ms-2" htmlFor="floatingInput">UPS Serial number</label>
                            </div>
                            <div className="form-floating mb-3 col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                id="floatingtext1"
                                placeholder="Device Name"
                                disabled
                              />
                              <label className="ms-2" htmlFor="floatingtext1">{device}</label>
                            </div>

                            <div className="form-floating mb-3 col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                id="floatingtext"
                                placeholder="Description"
                                disabled={isAdmin ? false : true}
                                value={desc}
                                onChange={(e) => {
                                  setDesc(e.target.value);
                                }}
                              />
                              <label className="ms-2" htmlFor="floatingtext">Remarks</label>
                            </div>
                            <div className="form-floating mb-3 col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                id="wifiSSID"
                                placeholder="Wifi SSID"
                                value={wifiSSID}
                                onChange={handleInputChange}
                              />
                              <label className="ms-2" htmlFor="floatingInput">Wifi SSID</label>
                            </div>
                            <div className="form-floating mb-3 col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                id="wifiPass"
                                placeholder="Wifi Password"
                                value={wifiPass}
                                onChange={handleInputChange}
                              />
                              <label className="ms-2" htmlFor="floatingInput">Wifi Password</label>
                            </div>
                            <div className="form-floating mb-3 col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                id="user_company"
                                placeholder="User Company"
                                value={userCompany}
                                onChange={handleInputChange}
                                disabled={isAdmin ? false : true}
                              />
                              <label className="ms-2" htmlFor="user_company">User Company</label>
                            </div>

                            <div className="row">
                              <label className="ms-2 fs-5 my-3">Address:</label>
                              <div className="form-floating mb-3 col-md-6">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="address"
                                  placeholder="Address"
                                  value={address}
                                  onChange={handleInputChange}
                                />
                                <label className="ms-2" htmlFor="address">Address</label>
                              </div>

                              <div className="form-floating mb-3 col-md-6">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="city"
                                  placeholder="District"
                                  value={city}
                                  onChange={handleInputChange}
                                />
                                <label className="ms-2" htmlFor="city">District</label>
                              </div>
                              <div className="form-floating mb-3 col-md-6">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="state"
                                  placeholder="State"
                                  value={state}
                                  onChange={handleInputChange}
                                />
                                <label className="ms-2" htmlFor="state">State</label>
                              </div>
                              <div className="form-floating mb-3 col-md-6">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="pin"
                                  placeholder="Postal Code"
                                  value={pin}
                                  onChange={handleInputChange}
                                />
                                <label className="ms-2" htmlFor="pin">Postal Code</label>
                              </div>
                              <div className="form-floating mb-3 col-md-6">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="latitude"
                                  placeholder="Latitude"
                                  value={latitude}
                                  onChange={handleInputChange}
                                />
                                <label className="ms-2" htmlFor="pin">Latitude</label>
                              </div>
                              <div className="form-floating mb-3 col-md-6">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="longitude"
                                  placeholder="Longitude"
                                  value={longitude}
                                  onChange={handleInputChange}
                                />
                                <label className="ms-2" htmlFor="pin">Longitude</label>
                              </div>
                            </div>

                            <button
                              type="submit"
                              onSubmit={handleSubmit}
                              className="btn btn-success float-end"
                            >
                              Save
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>

                    {/* <div className="tab-pane fade" id="profile-justified" role="tabpanel"
                                            aria-labelledby="profile-tab">
                                            <div className="row my-3 d-flex justify-content-center">
                                                <div className="col-sm-8">
                                                    


                                                </div>
                                            </div>
                                        </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
